{
  "familyId": "GET-GROOT-LEZEN",
  "questions": [
    {
      "id": "GET-GROOT-LEZEN-001",
      "familyId": "GET-GROOT-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je het getal 'drieduizend vierhonderdzevenentwintig' in cijfers?",
      "options": ["3.427", "3.472", "34.027", "3.247"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "groot_getal_woord_naar_cijfer",
      "variantIndex": 1,
      "citoDifficulty": 0.25,
      "citoDiscrimination": 0.72,
      "feedback": {
        "explanationText": "Splits het getal in stukken. 'Drieduizend' = 3.000, 'vierhonderd' = 400, 'zevenentwintig' = 27. Tel op: 3.000 + 400 + 27 = 3.427.",
        "solutionSteps": ["'Drieduizend' = 3.000", "'Vierhonderd' = 400", "'Zevenentwintig' = 27", "Tel op: 3.000 + 400 + 27 = 3.427"],
        "distractorExplanations": {
          "0": "Goed! Drieduizend (3.000) + vierhonderd (400) + zevenentwintig (27) = 3.427.",
          "1": "Je hebt de tientallen en eenheden omgedraaid. 'Zevenentwintig' = 27, niet 72. Schrijf het zo: zeven (7) op de eenhedenplek, twintig (20) op de tientallenplek → 27.",
          "2": "Je hebt 'drieduizend vierhonderd' als 34.000 geschreven. Maar 'drieduizend' = 3.000 en 'vierhonderd' = 400. Samen: 3.000 + 400 = 3.400, niet 34.000.",
          "3": "Je hebt de honderdtallen en tientallen omgedraaid. Het getal is 3.427: de 4 staat op de honderdtallenplek en de 2 op de tientallenplek. Onthoud: vierhonderd = 4 op de honderdtallenplek."
        }
      }
    },
    {
      "id": "GET-GROOT-LEZEN-002",
      "familyId": "GET-GROOT-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe lees je het getal 12.508?",
      "options": ["twaalfduizend vijfhonderdacht", "honderdvijfentwintigduizend acht", "twaalfduizend vijfhonderdtachtig", "éénduizend tweehonderdvijfhonderdacht"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "rule", "data": { "title": "Positiewaarden van 12.508", "content": "1 = tienduizendtallen\n2 = duizendtallen\n5 = honderdtallen\n0 = tientallen\n8 = eenheden\n\n12.508 = 10.000 + 2.000 + 500 + 0 + 8", "icon": "lightbulb" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Grote getallen lezen", "content": "Verdeel het getal bij de punt. Het deel vóór de punt zijn de duizendtallen. Het deel ná de punt zijn de honderdtallen, tientallen en eenheden. Voorbeeld: 12.508 = 12 duizend + 508.", "icon": "lightbulb" } }],
      "conceptId": "groot_getal_cijfer_naar_woord",
      "variantIndex": 2,
      "citoDifficulty": 0.3,
      "citoDiscrimination": 0.7,
      "feedback": {
        "explanationText": "Verdeel 12.508 in twee stukken bij de punt. 12 duizend = 'twaalfduizend'. 508 = vijfhonderd + 8 = 'vijfhonderdacht'. Samen: 'twaalfduizend vijfhonderdacht'.",
        "solutionSteps": ["Verdeel het getal bij de punt: 12 duizend en 508", "12 duizend = 'twaalfduizend'", "508 = vijfhonderd + 8 = 'vijfhonderdacht'", "Samen: 'twaalfduizend vijfhonderdacht'"],
        "distractorExplanations": {
          "0": "Goed! 12.508 = twaalfduizend vijfhonderdacht.",
          "1": "Je dacht waarschijnlijk dat de punt op een andere plek staat. Maar 12.508 = 12 duizend, niet 125 duizend. Onthoud: de punt scheidt de duizendtallen van de rest.",
          "2": "Je dacht waarschijnlijk dat 08 als tachtig wordt gelezen. Maar 08 = acht — de nul op de tientallenplek telt niet mee. Onthoud: 508 = vijfhonderd-en-acht, niet vijfhonderdtachtig.",
          "3": "Je dacht waarschijnlijk dat je elk cijfer apart leest. Maar 12.508 is één getal: twaalfduizend vijfhonderdacht. Onthoud: lees het als één geheel, niet als losse cijfers."
        }
      }
    },
    {
      "id": "GET-GROOT-LEZEN-003",
      "familyId": "GET-GROOT-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welk getal is 'vijftigduizend driehonderd'?",
      "options": ["50.300", "53.000", "5.300", "500.300"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "groot_getal_woord_naar_cijfer",
      "variantIndex": 3,
      "citoDifficulty": 0.28,
      "citoDiscrimination": 0.74,
      "feedback": {
        "explanationText": "Splits het getal. 'Vijftigduizend' = 50.000. 'Driehonderd' = 300. Tel op: 50.000 + 300 = 50.300. De tientallen en eenheden zijn 0.",
        "solutionSteps": ["'Vijftigduizend' = 50.000", "'Driehonderd' = 300", "Tel op: 50.000 + 300 = 50.300"],
        "distractorExplanations": {
          "0": "Goed! Vijftigduizend (50.000) + driehonderd (300) = 50.300.",
          "1": "Je hebt 'driehonderd' bij de duizendtallen geteld. Maar 'driehonderd' = 300, niet 3.000. 50.000 + 300 = 50.300, niet 53.000.",
          "2": "Je hebt 'vijftigduizend' als 'vijfduizend' gelezen. Vijftigduizend = 50.000 (vijf-tig = 50). Vijfduizend = 5.000. Let op het verschil!",
          "3": "Je hebt een extra nul toegevoegd. 'Vijftigduizend' = 50.000, niet 500.000. Vijfhonderdduizend zou 500.000 zijn."
        }
      }
    },
    {
      "id": "GET-GROOT-LEZEN-004",
      "familyId": "GET-GROOT-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Hoe schrijf je 'achthonderdduizend' in cijfers?",
      "options": ["800.000", "80.000", "8.000", "8.000.000"],
      "correctAnswer": 0,
      "stimulusAids": [],
      "supportAids": [],
      "conceptId": "groot_getal_woord_naar_cijfer",
      "variantIndex": 4,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.68,
      "feedback": {
        "explanationText": "Splits het woord. 'Achthonderd' = 800. 'Duizend' betekent × 1.000. Bereken: 800 × 1.000 = 800.000. Achthonderdduizend heeft 6 cijfers.",
        "solutionSteps": ["'Achthonderd' = 800", "'Duizend' betekent × 1.000", "Bereken: 800 × 1.000 = 800.000"],
        "distractorExplanations": {
          "0": "Goed! Achthonderdduizend = 800 × 1.000 = 800.000.",
          "1": "Je hebt een nul vergeten. 80.000 = tachtigduizend, niet achthonderdduizend. Achthonderdduizend = 800.000 (6 cijfers), tachtigduizend = 80.000 (5 cijfers).",
          "2": "Je hebt 'achthonderd' als 'acht' gelezen. Maar 'achthonderd' = 800. 800 × 1.000 = 800.000, niet 8.000.",
          "3": "Je hebt te veel nullen toegevoegd. 8.000.000 = acht miljoen. Achthonderdduizend = 800.000 (6 cijfers), acht miljoen = 8.000.000 (7 cijfers)."
        }
      }
    },
    {
      "id": "GET-GROOT-LEZEN-005",
      "familyId": "GET-GROOT-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_lezen_schrijven",
      "questionType": "multiple_choice",
      "question": "Welk getal staat hier: 206.040?",
      "options": ["tweehonderdzesduizend veertig", "tweehonderdzesduizend vierhonderd", "twintigduizend zeshonderdveertig", "twee miljoen zesduizend veertig"],
      "correctAnswer": 0,
      "stimulusAids": [{ "type": "rule", "data": { "title": "Positiewaarden van 206.040 — let op de nullen!", "content": "2 = honderdduizendtallen\n0 = tienduizendtallen\n6 = duizendtallen\n0 = honderdtallen\n4 = tientallen\n0 = eenheden\n\n206.040 = 200.000 + 0 + 6.000 + 0 + 40 + 0", "icon": "lightbulb" } }],
      "supportAids": [{ "type": "rule", "showWhen": "wrong", "data": { "title": "Getallen met nullen lezen", "content": "Nullen in een getal worden niet uitgesproken. Verdeel bij de punt: 206.040 = 206 duizend + 040. 040 = veertig (de nul op de honderdtallenplek telt niet mee).", "icon": "lightbulb" } }],
      "conceptId": "groot_getal_cijfer_naar_woord_nul",
      "variantIndex": 5,
      "citoDifficulty": 0.42,
      "citoDiscrimination": 0.71,
      "feedback": {
        "explanationText": "Verdeel 206.040 in twee stukken bij de punt. 206 duizend = 'tweehonderdzesduizend'. 040 = veertig (de nul op de honderdtallenplek telt niet mee). Samen: 'tweehonderdzesduizend veertig'.",
        "solutionSteps": ["Verdeel het getal bij de punt: 206 duizend en 040", "206 duizend = 'tweehonderdzesduizend'", "040 = veertig (de nul telt niet mee)", "Samen: 'tweehonderdzesduizend veertig'"],
        "distractorExplanations": {
          "0": "Goed! 206.040 = tweehonderdzesduizend veertig.",
          "1": "Je dacht waarschijnlijk dat 040 vierhonderd is. Maar de 0 staat op de honderdtallenplek en de 4 op de tientallenplek. Onthoud: 040 = veertig, niet vierhonderd.",
          "2": "Je dacht waarschijnlijk dat de punt op een andere plek staat. Maar 206.040 = 206 duizend, niet 20 duizend. Onthoud: de punt scheidt de duizendtallen van de rest.",
          "3": "Je dacht waarschijnlijk dat de punt miljoenen aangeeft. Maar 206.040 = tweehonderdzesduizend, niet twee miljoen. Onthoud: twee miljoen = 2.000.000 (met twee punten)."
        }
      }
    },
    {
      "id": "GET-GROOT-LEZEN-006",
      "familyId": "GET-GROOT-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_lezen_schrijven",
      "questionType": "ordering",
      "question": "Zet deze getallen van klein naar groot:",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "items": ["85.000", "8.500", "805.000", "58.000", "508.000"],
        "correctOrder": [1, 3, 0, 4, 2]
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Grote getallen vergelijken",
            "content": "Kijk eerst naar het aantal cijfers. Meer cijfers = groter getal. Bij gelijk aantal cijfers: vergelijk van links naar rechts. 8.500 (4 cijfers) < 58.000 (5 cijfers) < 85.000 (5 cijfers) < 508.000 (6 cijfers) < 805.000 (6 cijfers).",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "groot_getal_ordenen",
      "variantIndex": 6,
      "citoDifficulty": 0.35,
      "citoDiscrimination": 0.72,
      "pedagogy": { "dok": 2 },
      "feedback": {
        "explanationText": "Vergelijk het aantal cijfers: 8.500 heeft 4 cijfers, 58.000 en 85.000 hebben 5 cijfers, 508.000 en 805.000 hebben 6 cijfers. Bij gelijk aantal cijfers vergelijk je van links naar rechts: 58.000 < 85.000 (5 < 8) en 508.000 < 805.000 (5 < 8). Volgorde: 8.500 < 58.000 < 85.000 < 508.000 < 805.000.",
        "solutionSteps": [
          "Tel de cijfers: 8.500 (4), 58.000 (5), 85.000 (5), 508.000 (6), 805.000 (6)",
          "4 cijfers < 5 cijfers < 6 cijfers",
          "Bij 5 cijfers: 58.000 < 85.000 (vergelijk eerste cijfer: 5 < 8)",
          "Bij 6 cijfers: 508.000 < 805.000 (vergelijk eerste cijfer: 5 < 8)",
          "Volgorde: 8.500 < 58.000 < 85.000 < 508.000 < 805.000"
        ]
      }
    },
    {
      "id": "GET-GROOT-LEZEN-007",
      "familyId": "GET-GROOT-LEZEN",
      "module": "Getalbegrip",
      "tier": 1,
      "levelCode": "B6",
      "group": 6,
      "skill": "positiestelsel",
      "subSkill": "groot_lezen_schrijven",
      "questionType": "fill_in",
      "question": "Schrijf het getal 'zesenzeventigduizend vierhonderdtwaalf' in cijfers.",
      "options": [],
      "correctAnswer": 0,
      "data": {
        "acceptedAnswers": ["76.412", "76412"],
        "caseSensitive": false,
        "placeholder": "Typ het getal..."
      },
      "stimulusAids": [],
      "supportAids": [
        {
          "type": "rule",
          "showWhen": "wrong",
          "data": {
            "title": "Getalwoord → cijfers",
            "content": "Splits het woord in stukken. 'Zesenzeventigduizend' = 76.000. 'Vierhonderdtwaalf' = 412. Tel op: 76.000 + 412 = 76.412.",
            "icon": "lightbulb"
          }
        }
      ],
      "conceptId": "groot_getal_woord_naar_cijfer_fill",
      "variantIndex": 7,
      "citoDifficulty": 0.32,
      "citoDiscrimination": 0.70,
      "pedagogy": { "dok": 1 },
      "feedback": {
        "explanationText": "Splits het woord: 'zesenzeventigduizend' = 76.000 en 'vierhonderdtwaalf' = 412. Tel op: 76.000 + 412 = 76.412. Tip: 'zesenzeventig' = 76 (zes-en-zeventig), dus 76 × 1.000 = 76.000.",
        "solutionSteps": [
          "'Zesenzeventigduizend' = 76 × 1.000 = 76.000",
          "'Vierhonderdtwaalf' = 400 + 12 = 412",
          "Tel op: 76.000 + 412 = 76.412"
        ]
      }
    }
  ]
}